// Note: This is only temporary to remove the HTML from the legal fields
const stripHtmlFromString = (content: string | HTMLElement): string => {
    if (!content) {
        return '';
    }

    const tmp = document.createElement('div');
    tmp.innerHTML = String(content);

    return tmp.textContent || '';
};

export default stripHtmlFromString;
